/**
 * Canadian postal code utilities.
 *
 * Canonical format: A1A 1A1
 *   - Uppercase letter, digit, uppercase letter, single space,
 *     digit, uppercase letter, digit
 *   - No special characters
 *
 * Used by the Checkout flow to guarantee we never send a malformed
 * postal code to our /address/verify endpoint (which proxies LOB).
 */

export const CA_POSTAL_REGEX = /^[A-Z]\d[A-Z] \d[A-Z]\d$/;

/**
 * Strip all non-alphanumeric characters, uppercase, and insert the
 * canonical single space between the FSA and LDU when we have the
 * full 6 characters. Returns the partially-cleaned value otherwise
 * so downstream validation can show an appropriate error.
 */
export const normalizeCaPostal = (raw) => {
  if (raw == null) return "";
  const cleaned = String(raw).toUpperCase().replace(/[^A-Z0-9]/g, "");
  if (cleaned.length <= 3) return cleaned;
  return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)}`;
};

export const isValidCaPostal = (value) =>
  CA_POSTAL_REGEX.test(normalizeCaPostal(value));

export const POSTAL_FORMAT_MESSAGE =
  "Postal code must be in the format A1A 1A1.";
